module.exports = __webpack_public_path__ + "img/电梯动画12.eb42f669.png";